import React from "react";
import ProjectCardBody from "./ProjectCardBody";

function Projects() {

    const projects = [
        {
            title: "QNA RAG, Conversational Knowledge Retrieval from PDFs",
            description: [
                "Developed a conversational interface using Streamlit, Chroma DB, PyPDF2, HuggingFace embeddings, and Python to facilitate user interaction.",
                "Implemented PDF processing and text-to-vector conversion for efficient document handling and retrieval, utilizing HuggingFace embeddings and storing vectors in the vector database.",
                "Designed a conversational retrieval chain leveraging the Mistralai version 0.2 model for providing relevant responses to user queries."
            ],
            projectLink: "https://github.com/mohitkumarrajbadi/QNA-RAG",
            date: "[04/2024 - 05/2024]"
        },
        {
            title: "Grab A Cycle",
            date: "[01/2023 - 02/2023]",
            projectLink: "https://github.com/mohitkumarrajbadi/grab_a_cycle"
        },
        {
            title: "Social Media DApp",
            date: "[03/2020 - 05/2020]",
            projectLink: "https://github.com/mohitkumarrajbadi/social_media_app"
        },
        {
            title: "SCA Student Resource",
            date: "[01/2019 - 03/2019]",
            projectLink: "https://github.com/mohitkumarrajbadi/sca-study-resource-management"
        }
    ];

    return (
        <>
            <div className="project-section container-fluid">
                <h1 className="section-heading">#Projects</h1>
                <div className="projectCards">
                    <ProjectCardBody/>
                </div>
            </div>
        </>
    );
}

export default Projects;
